export class ExternalAccountModel {
	id: number;
	title: string;
	login_url: string;
	type: string;
}
